"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseCategories = void 0;
/**
 * Utility to filter categories with thruthy data and map them to `CategoryBoxProps` type.
 * @returns Categories with thruthy data
 */ const parseCategories = (param)=>{
    let { categories } = param;
    return (categories !== null && categories !== void 0 ? categories : []).filter((category)=>!!category).filter((param)=>{
        let { link, themeTag, thumbnailUrl } = param;
        return !!(link === null || link === void 0 ? void 0 : link.relativeUrl) && !!themeTag && !!thumbnailUrl;
    }).map((param)=>{
        let { link, themeTag, thumbnailUrl } = param;
        var _link_relativeUrl;
        return {
            imageUrl: thumbnailUrl,
            relativeUrl: (_link_relativeUrl = link === null || link === void 0 ? void 0 : link.relativeUrl) !== null && _link_relativeUrl !== void 0 ? _link_relativeUrl : '',
            title: themeTag
        };
    });
};
exports.parseCategories = parseCategories;
